<template>
  <GroupedAggregateRowsDataSourceForm
    v-if="dataSource"
    ref="dataSourceForm"
    :dashboard="dashboard"
    :widget="widget"
    :data-source="dataSource"
    :store-prefix="storePrefix"
    :loading="loading"
    @values-changed="onDataSourceValuesChanged"
  />
</template>

<script>
import GroupedAggregateRowsDataSourceForm from '../data_source/GroupedAggregateRowsDataSourceForm'
import error from '@baserow/modules/core/mixins/error'
import { notifyIf } from '@baserow/modules/core/utils/error'
import debounce from 'lodash/debounce'
import isEqual from 'lodash/isEqual'

export default {
  name: 'VokalisChartWidgetSettings',
  components: { GroupedAggregateRowsDataSourceForm },
  mixins: [error],
  props: {
    dashboard: { type: Object, required: true },
    widget: { type: Object, required: true },
    storePrefix: { type: String, required: false, default: '' },
  },
  data() {
    return {
      loading: false,
      debouncedUpdateDataSource: null,
      lastQueuedValues: null,
    }
  },
  created() {
    this.debouncedUpdateDataSource = debounce(async (changedDataSourceValues) => {
      const formRef = this.$refs.dataSourceForm
      if (!formRef || !formRef.isFormValid || !formRef.isFormValid()) {
        return
      }
      if (!this.dataSource) {
        return
      }
      if (this.isPayloadEqualToCurrentDataSource(changedDataSourceValues)) {
        return
      }
      try {
        await this.$store.dispatch(
          `${this.storePrefix}dashboardApplication/updateDataSource`,
          {
            dataSourceId: this.dataSource.id,
            values: changedDataSourceValues,
            widget: this.widget,
          }
        )
      } catch (err) {
        if (typeof formRef.reset === 'function') {
          formRef.reset()
        }
        if (typeof formRef.touch === 'function') {
          formRef.touch()
        }
        notifyIf(err, 'dashboard')
      }
    }, 200)
  },
  beforeUnmount() {
    if (this.debouncedUpdateDataSource?.cancel) {
      this.debouncedUpdateDataSource.cancel()
    }
  },
  computed: {
    dataSource() {
      return this.$store.getters[
        `${this.storePrefix}dashboardApplication/getDataSourceById`
      ](this.widget.data_source_id)
    },
  },
  methods: {
    isPayloadEqualToCurrentDataSource(values) {
      if (!this.dataSource) return false
      const current = {
        table_id: this.dataSource.table_id || null,
        view_id: this.dataSource.view_id || null,
        aggregation_series: this.dataSource.aggregation_series || [],
        aggregation_group_bys: this.dataSource.aggregation_group_bys || [],
        aggregation_sorts: this.dataSource.aggregation_sorts || [],
      }
      return isEqual(current, values)
    },
    async onDataSourceValuesChanged(changedDataSourceValues) {
      const formRef = this.$refs.dataSourceForm
      if (!formRef || typeof formRef.isFormValid !== 'function') {
        return
      }

      if (!formRef.isFormValid()) {
        return
      }
      if (isEqual(this.lastQueuedValues, changedDataSourceValues)) {
        return
      }
      this.lastQueuedValues = JSON.parse(JSON.stringify(changedDataSourceValues))
      this.debouncedUpdateDataSource(changedDataSourceValues)
    },
  },
}
</script>

<style scoped>
/* No extra styles for now */
</style>

